// 本地缓存读写：JSON 序列化 + 容错。统一 crirp_ 前缀。
// 用于首屏秒开（stale-while-revalidate）：data() 同步读、后台静默刷新。
const PREFIX = 'crirp_'

export function cacheGet(key, fallback = null) {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    if (raw == null) return fallback
    return JSON.parse(raw)
  } catch (e) {
    return fallback
  }
}

export function cacheSet(key, value) {
  // 配额溢出 / 隐私模式：静默丢弃，不影响主流程
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch (e) { /* ignore */ }
}

// 进程内缓存（列表页专用）：F5 刷新即失效（JS 上下文重建）→ 「刷新回顶部、全新加载」；
// 同一会话内跨路由切换 / 详情页后退仍命中，保留 stale-while-revalidate 秒开。
// 与 cacheGet/cacheSet 对称，但底层是 Map，不序列化、不持久化。
const _mem = new Map()
export function memGet(key, fallback = null) {
  return _mem.has(key) ? _mem.get(key) : fallback
}
export function memSet(key, value) {
  _mem.set(key, value)
}
export function memDel(key) {
  _mem.delete(key)
}
